import React, { useEffect, useMemo, useRef } from "react";
import { getChargebackVolume } from "../../../../../api";
import Spinner from "../../../../components/Loaders/Spinner";
import useCommonStore from "../../../../stores/common";
import useMerchantStore from "../../../../stores/merchant";
import ChargebackTabs from "./ChargebackTabs/ChargebackTabs";
import ChargebackVolumeChart from "./ChargebackVolumeChart";
import ScoreCard from "./ScoreCard";
import SlidingTab from "../../../../components/SlidingTab/SlidingTab";
import MobileDesktopAlert from "../../../../components/MobileDesktopAlert";
import style from "./Chargeback.module.scss";
import SkeletonLoader from "../../../../components/skeleton-loader";

function Chargeback() {
  const expandDetails = useCommonStore((state) => state.expandDetails);
  const activeApp = useMerchantStore((state) => state.activeApp);
  const chargebackType = useMerchantStore(
    (state) => state.chargebacksVolumeFilter.type,
  );
  const loadedOnce = useRef(false);
  const chargebacksDataLoading = useMerchantStore(
    (state) => state.chargebacksDataLoading,
  );
  const setChargebacksData = useMerchantStore(
    (state) => state.setChargebacksData,
  );
  const setChargebacksDataLoading = useMerchantStore(
    (state) => state.setChargebacksDataLoading,
  );
  const setChargebacksVolumeFilter = useMerchantStore(
    (state) => state.setChargebacksVolumeFilter,
  );
  const chargebacksData = useMerchantStore((state) => state.chargebacksData);
  const chargebacksFilterYear = useMerchantStore(
    (state) => state.chargebacksVolumeFilter.year,
  );
  const chargebacksFilterType = useMerchantStore(
    (state) => state.chargebacksVolumeFilter.type,
  );

  const dateRange = useCommonStore((state) => state.dateRange);

  useEffect(() => {
    const abortController = new AbortController();
    setChargebacksDataLoading(true);
    getChargebackVolume(
      {
        mid: activeApp?.power_app_submission?.mid,
        type: chargebackType,
        start_date: dateRange.startDate,
        end_date: dateRange.endDate,
        rangeType: dateRange.rangeType,
      },
      abortController,
    )
      .then((res) => {
        setChargebacksData(res.data);
        setChargebacksDataLoading(false);
        loadedOnce.current = true;
      })
      .catch((err) => {
        console.log(err);
      });

    return () => {
      abortController.abort();
    };
  }, [
    activeApp?.power_app_submission?.mid,
    chargebackType,
    setChargebacksData,
    setChargebacksDataLoading,
    dateRange.startDate,
    dateRange.endDate,
    dateRange.rangeType,
  ]);

  return (
    <div className={style.chargeback_container}>
      <div className={`${style.charts} ${expandDetails ? style.expanded : ""}`}>
        {chargebacksDataLoading && (
          <div className={style.volumeChartContainer}>
            <div className={style.volumeChartHeader}>
              <h5>Chargebacks volume</h5>
              {!loadedOnce.current && (
                <div
                  className={style.volumeChartButtons}
                  style={{ justifyContent: "flex-end" }}
                >
                  <SkeletonLoader
                    variant="rectangular"
                    width="120px"
                    height="32px"
                  />
                </div>
              )}
            </div>

            <SkeletonLoader
              variant="rectangular"
              width="100%"
              height="270px"
              style={{ marginTop: "8px" }}
            />
          </div>
        )}

        {!chargebacksDataLoading && (
          <div className={style.volumeChartContainer}>
            <div className={style.volumeChartHeader}>
              <h5>Chargebacks volume</h5>
              <div
                className={`${style.volumeChartButtons} ${chargebacksDataLoading ? style.disabled : ""} `}
              >
                <SlidingTab
                  selectedTab={
                    chargebackType.charAt(0).toUpperCase() +
                    chargebackType.slice(1)
                  }
                  options={["Volume", "Amount"]}
                  onChange={(tab) => {
                    setChargebacksVolumeFilter({ type: tab.toLowerCase() });
                  }}
                  fullWidth
                />
              </div>
            </div>

            <ChargebackVolumeChart
              data={chargebacksData}
              filter={{
                type: chargebackType,
                year: chargebacksFilterYear,
              }}
            />
          </div>
        )}

        <ScoreCard />
      </div>
      <div className={style.tabs_section}>
        <ChargebackTabs />
      </div>
      <MobileDesktopAlert message="See more details on the desktop version" />
    </div>
  );
}

export default Chargeback;
